import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
    state: () => {
        return {
            lang: 'ru',
            notificationText: null,
            notificationType: null,
        }
    },
    actions: {
        setLang(lang) {
            this.lang = lang
        },

        showNotification(text = null, type = null) {
            if (text) {
                this.notificationText = text
                this.notificationType = type

                setTimeout(() => {
                    this.notificationText = null
                    this.notificationType = null
                }, 3000)
            }
        },

        hideNotification() {
            this.notificationText = null
            this.notificationType = null
        },
    },
    getters: {
        getCurrentLang() {
            return this.lang
        },
    },
})
